/* SIZESOFTX
=========================================================================================
* Descripción: Punto de entrada del panel de soporte SizeSoftX
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/09/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { SupportAuthProvider } from "./context/SupportAuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SupportAuthProvider>
      <App />
    </SupportAuthProvider>
  </React.StrictMode>
);